import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";

class labs extends Component {
    state = {
    }

    componentDidMount() {
        var path = window.location.pathname
        path = path.slice(1, 3);
        if (path === 'en') {
            require("./lab.css");
        } else if (path === 'sc') {
            require("./lab_sc.css");
        } else if (path === 'tc') {
            require("./lab_tc.css");
        }
    }
    render() {
        const { t } = this.props;
        let path = window.location.pathname;
        let match = path.slice(0, 3);

        return (
            <div className={match === "/tc" ? "tc d-flex justify-content-center" : match === "/sc" ? "sc d-flex justify-content-center" : "d-flex justify-content-center"}>
                <MetaTags>
                    <title>{t('lab-meta-title')}</title>
                    <meta name="title" content={t('lab-meta-title')} />
                    <meta name="description" content={t('lab-meta-description')} />
                    <meta name="keywords" content={t('lab-meta-keywords')} />
                </MetaTags>
                <div id="div-lab">
                    <div className={t('lab-content-1')}></div>
                    <a href={t('lab-pre-link')} target="_blank" ><div className={t('lab-content-2')}></div></a>
                    <Footer />
                    {/*  Modal */}
                    <div className="modal fade" id="myModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content bg-black">
                                <div className="modal-body">
                                    <div className="d-flex justify-content-end">
                                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>


                                    <p>{t('alert-msg-1')}</p>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(labs);



// WEBPACK FOOTER //
// ./src/components/pages/lab.js